/**
 * Sortable column header for modal list tables (TempForms pattern).
 */
export default function SortableTableHeader({
  label,
  sortKey,
  sortBy,
  sortOrder = "asc",
  onSort,
  className = "",
}) {
  const active = sortBy === sortKey;

  return (
    <th className={`text-left px-3 py-2 ${className}`}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className="font-semibold text-gray-600 hover:underline"
      >
        {label}
        {active ? (
          <span className="ml-1">{sortOrder === "asc" ? "\u25B2" : "\u25BC"}</span>
        ) : null}
      </button>
    </th>
  );
}

/** Non-sortable column header */
export function TableHeaderCell({ label, className = "" }) {
  return <th className={`text-left px-3 py-2 text-gray-600 ${className}`}>{label}</th>;
}
